import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { IoClose } from 'react-icons/io5';

import Modal from 'react-modal';
import { Spinner } from 'components/Loading';
import { styledTheme } from 'globalStyles/theme';
import './styles.scss';

const APModal = ({
  open,
  onClose,
  name,
  hasHeader = true,
  title,
  subtitle,
  actions,
  size = null,
  className,
  shouldCloseOnOverlayClick = true,
  isLoading = false,
  errorMsg,
  children,
  style,
  ...rest
}) => {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={open}
      contentLabel="PodoModal"
      className={clsx('ap-modal', `${name}-modal`, size && `ap-modal--${size}`, className)}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onClose}
      parentSelector={() => window.appRootMountPoint || document.body}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 0,
          backgroundColor: styledTheme.modalBackground,
          zIndex: 999,
          ...style,
        },
      }}
      {...rest}
    >
      {hasHeader && (
        <div
          className={`ap-modal__header ${name}-modal__header`}
          onClick={onClose}
        >
          <IoClose
            className={`ap-modal__close ${name}-modal__close`}
            size={20}
            onClick={onClose}
          />
        </div>
      )}
      <div className={`ap-modal__body ${name}-modal__body`}>
        <h2 className={`ap-modal__title ${name}-modal__title`}>
          {title}
        </h2>
        {subtitle && (
          <p className={`ap-modal__subtitle ${name}-modal__subtitle`}>
            {subtitle}
          </p>
        )}
        {isLoading ? (
          <div className="ap-modal__loader">
            <Spinner />
          </div>
        ) : (
          <>
            <div className={`ap-modal__content ${name}-modal__content`}>
              {children}
            </div>
            <div className={`ap-modal__actions ${name}-modal__actions`}>
              {(errorMsg && errorMsg !== '') && (
                <div className={`ap-modal__error-msg ${name}-modal__error-msg`}>
                  {errorMsg}
                </div>
              )}
              {actions}
            </div>
          </>
        )}

      </div>
    </Modal>
  );
};

APModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  name: PropTypes.string,
  hasHeader: PropTypes.bool,
  title: PropTypes.string,
  actions: PropTypes.element,
};

export default APModal;
